import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import useFonts from '../../hooks/useFonts';
import { useSite, withTheme } from '../../contexts/SiteContext';
import LoadingBar from '../partials/LoadingBar';

import defaultFonts from './fonts';

import styles from '../../../styles/layouts/game.module.scss';

const propTypes = {
    children: PropTypes.node.isRequired,
    pageIsLoaded: PropTypes.bool,
    loadingColor: PropTypes.string,
    textColor: PropTypes.string,
    fonts: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.array])),
};

const defaultProps = {
    pageIsLoaded: false,
    loadingColor: null,
    textColor: null,
    fonts: defaultFonts,
};

function SimpleLayout({ fonts, children, pageIsLoaded, loadingColor, textColor }) {
    const site = useSite();
    const finalFonts = useMemo(
        () =>
            site.id === 'quatre95'
                ? fonts.filter(it => (Array.isArray(it) ? it[0] : it) !== 'Apercu')
                : fonts.filter(it => (Array.isArray(it) ? it[0] : it) !== 'Maax'),
        [fonts, site.id],
    );
    const { loaded: fontsLoaded } = useFonts(finalFonts);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.fontsLoaded]: fontsLoaded,
                },
            ])}
            style={{
                color: textColor,
            }}
        >
            <div className={styles.loading}>
                <LoadingBar loading={!pageIsLoaded} loaded={pageIsLoaded} color={loadingColor} />
            </div>
            <div className={styles.inner}>
                <div className={styles.content}>{children}</div>
            </div>
        </div>
    );
};

SimpleLayout.propTypes = propTypes;
SimpleLayout.defaultProps = defaultProps;

const WithThemeContainer = withTheme(
    SimpleLayout,
    ({ textColor, header: { loadingColor } = {} }) => ({
        loadingColor,
        textColor,
    }),
);

export default WithThemeContainer;
